export function reloadPage(): void {
  location.reload();
}

/**
 * The `reloadOnCatch` function is used to handle errors that occur when a module is missing, typically because a newer version of the application is available.
 * In such cases, this function will trigger a page reload, which should load the newer version of the application with the updated modules.
 *
 * @param {Promise<T>} promise - The promise that may reject if a module is missing.
 * @returns {Promise<T>} A new promise that will either resolve with the original promise's value, or reject and trigger a page reload.
 */
export function reloadOnCatch<T>(promise: Promise<T>): Promise<T> {
  // it will reload page anyway, so we can assume type safety
  return promise.catch(reloadPage) as Promise<T>;
}
